import {
    FETCH_MESSAGES_SUCCESS,
    FETCH_MESSAGES_FAILURE,
    CREATE_MESSAGE_SUCCESS,
    CREATE_MESSAGE_FAILURE,
    UPDATE_MESSAGE_SUCCESS,
    UPDATE_MESSAGE_FAILURE,
    THUMBS_UP_SUCCESS,
    THUMBS_UP_FAILURE,
    THUMBS_DOWN_SUCCESS,
    THUMBS_DOWN_FAILURE,
    COPY_MESSAGE_SUCCESS,
    COPY_MESSAGE_FAILURE,
    GENERATE_MESSAGE_SUCCESS,
    GENERATE_MESSAGE_FAILURE,
    REGENERATE_BUTTON_SUCCESS,
    REGENERATE_BUTTON_FAILURE,
    CLEAR_MESSAGES_SUCCESS,
    SUBMIT_FEEDBACK_FAILURE,
    SUBMIT_FEEDBACK_SUCCESS,
    CLEAR_MESSAGE_ERROR,
  } from './actionTypes.js';
  
  import {
    fetchMessages as fetchMessagesApi,
    createMessage as createMessageApi,
    updateThumbsUp as updateThumbsUpApi,
    updateThumbsDown as updateThumbsDownApi,
    copyMessage as copyMessageApi,
    generateMessage as generateMessageApi,
    updateMessage as updateMessageApi,
    regenerateButton as regenerateButtonApi,
    submitFeedback as submitFeedbackApi
  } from '../../services/api.js';

  export const fetchMessages = (user_id, chat_id) => async (dispatch) => {
    try {
      const response = await fetchMessagesApi(user_id, chat_id);
      response.data.sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp));

      dispatch({
        type: FETCH_MESSAGES_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: FETCH_MESSAGES_FAILURE,
        payload: error.message,
      });
    }
  };
  
  export const createMessage = (user_id, chat_id, role, content) => async (dispatch) => {
    try {
      const response = await createMessageApi(user_id, chat_id, role, content);
      dispatch({
        type: CREATE_MESSAGE_SUCCESS,
        payload: response.data,
      });
      return response.data.message_id;
    } catch (error) {
      dispatch({
        type: CREATE_MESSAGE_FAILURE,
        payload: error.message,
      });
      return null;
    }
  };

  export const regenerateButton = (user_id, message_id) => async (dispatch) => {
    try {
      const response = await regenerateButtonApi(user_id, message_id);
      dispatch({
        type: REGENERATE_BUTTON_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: REGENERATE_BUTTON_FAILURE,
        payload: error.message,
      });
    }
  };

  export const thumbsUp = (user_id, message_id) => async (dispatch) => {
    try {
      const response = await updateThumbsUpApi(user_id, message_id);
      dispatch({
        type: THUMBS_UP_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: THUMBS_UP_FAILURE,
        payload: error.message,
      });
    }
  };

  export const thumbsDown = (user_id, message_id) => async (dispatch) => {
    try {
      const response = await updateThumbsDownApi(user_id, message_id);
      dispatch({
        type: THUMBS_DOWN_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: THUMBS_DOWN_FAILURE,
        payload: error.message,
      });
    }
  };
  
  export const submitFeedback = (user_id, message_id, feedback_message, feedback_sources) => async (dispatch) => {
    try {
      const response = await submitFeedbackApi(user_id, message_id, feedback_message, feedback_sources);
      dispatch({
        type: SUBMIT_FEEDBACK_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: SUBMIT_FEEDBACK_FAILURE,
        payload: error.message,
      });
    }
  };

  export const copyMessage = (user_id, message_id) => async (dispatch) => {
    try {
      const response = await copyMessageApi(user_id, message_id);
      dispatch({
        type: COPY_MESSAGE_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: COPY_MESSAGE_FAILURE,
        payload: error.message,
      });
    }
  };

  export const updateMessage = (user_id, message_id, content) => async (dispatch) => {
    try {
      const response = await updateMessageApi(user_id, message_id, content);
      dispatch({
        type: UPDATE_MESSAGE_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: UPDATE_MESSAGE_FAILURE,
        payload: error.message,
      });
    }
  }
  
  export const generateMessage = (user_id, query, modelName, chatHistory, message_id) => async (dispatch) => {
    try {
      const reader = await generateMessageApi(user_id, query, modelName, chatHistory);
      const decoder = new TextDecoder();
      let result = '';
      let done, value;

      while (!done) {
        const res = await reader.read();
        done = res.done
        value = res.value

        let chunk = decoder.decode(value, { stream: true });
        result += chunk

        dispatch({
          type: GENERATE_MESSAGE_SUCCESS,
          payload: { chunk, message_id },
        });
      }
      return result
    } catch (error) {
      dispatch({
        type: GENERATE_MESSAGE_FAILURE,
        payload: error.message,
      });
    }
  };
  
  export const clearMessages = () => (dispatch) => {
    dispatch({ type: CLEAR_MESSAGES_SUCCESS });
  };

  export const clearMessageError = () => ({
    type: CLEAR_MESSAGE_ERROR,
  });